import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * LAAC-2432 homepage curated collections carousel.
 */
export const useCuratedCollectionsExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.CuratedCollections, AmplitudeVariants.CuratedCollections.Treatment);
